
import { useContext, useState } from 'react';
import './FamOrNannyRegister.css';
import { LoadState, UserType } from '../common/enums';
import { LocaleContext, LoginContext } from '../common/App';
import { ForwardsBackwardsBar, NavigateSmart, RadioCheckButton } from '../common/Common';
import { useNavigateSmart } from '../common/hooks';


export function FamOrNannyRegister(props) {
    const locale = useContext(LocaleContext);
    const login = useContext(LoginContext);

    const navigate = useNavigateSmart();

    const [userType, setUserType] = useState(UserType.NONE);

    // FUNCTIONS:

    function handleContinue() {
        if(userType === UserType.FAMILY) {
            navigate("/register_fam");
        }
        else if(userType === UserType.NANNY) {
            navigate("/register_mn");
        }
    }

    // EFFECTS:

    // RENDER:

    return (
        <div id="fam_or_nanny_register" className="side_padding bottom_padding">
            { login.loggedIn ?
                <NavigateSmart to="/dashboard" />
            :
                null
            }

            <FamOrNanny userType={userType} onUserTypeChange={ (type) => setUserType(type.user_type)} />

            <div id="forwards_backwards_bar_wrap_box" className="forwards_backwards_bar_wrap_box">
                <ForwardsBackwardsBar backwardsVisible={false} forwardsVisible={true}
                                backwardsClickable={false} forwardsClickable={userType !== UserType.NONE}
                                onBackwards={() => {}} onForwards={handleContinue}
                                backwardsText={""} forwardsText={locale.msgs.CONTINUE}
                                forwardsLoadState={LoadState.NONE} />
            </div>
        </div>
    );
}

function FamOrNanny(props) {
    const locale = useContext(LocaleContext);

    let initArr = Array(2).fill(false);

    if(props.userType["user_type"] == UserType.NANNY){
        initArr[0] = true;
    }
    else if(props.userType["user_type"] == UserType.FAMILY) {
        initArr[1] = true;
    }

    let [btnCheckedState, setBtnCheckedState] = useState(initArr);

    function handleChange(e){
        let newBtnCheckedState = Array(2).fill(false);
        newBtnCheckedState[e.target.id] = true;
        setBtnCheckedState(newBtnCheckedState);

        if(e.target.id == "0"){
            props.onUserTypeChange({"user_type": UserType.NANNY});
        }
        else if(e.target.id == "1"){
            props.onUserTypeChange({"user_type": UserType.FAMILY});
        }
    }

    return(
        <div id="fam_or_nannny">
            <div className="head">{locale.msgs.WHAT_ARE_YOU_LOOKING_FOR}</div>
            <div className="text">{locale.msgs.WHAT_ARE_YOU_LOOKING_FOR_DESCR}</div>

            <div id="radio_one">
                <RadioCheckButton type="radio" text={locale.msgs.A_JOB} id="0" name="fam_nan" checked={btnCheckedState[0]} onChange={(e) => handleChange(e)}/>
            </div>
            
            <div id="radio_two">
                <RadioCheckButton type="radio" text={locale.msgs.A_NANNY} id="1" name="fam_nan" checked={btnCheckedState[1]} onChange={(e) => handleChange(e)}/>
            </div>
        </div>
    );
}
